import {EditFieldInterface} from "@/views/Admin/Statistic/Member/EditField/EditField.interface";
import {FieldSchema} from "@/schema/Field.schema";

export const EditFieldSchema: EditFieldInterface = {
    regionList: null,
    fieldValue: {
        data: null,
        event_order_form_id: null,
        event_order_ticket_id: null,
        form_id: null,
        id: null,
    },
    editInput: FieldSchema,
}
